<!-- ══════════════════════════════════════════════════════════════════════════════════════
     LA FICHE TIERS — « L'EN-TÊTE ET LES ADRESSES »

     UNE SEULE COLONNE, lue de haut en bas. Aucune découpe verticale de la fenêtre.

       1. L'EN-TÊTE porte TOUT le tiers, en TROIS COLONNES pleine hauteur (60 / 20 / 20) : son
          nom, sa référence, ses trois rôles, ses neuf champs d'identité (civilité, nom, prénom,
          e-mail, deux téléphones, paiement, activité), ses champs utilisateur (forme
          juridique, encours, poids, taille, date de décès) et son mémo ; SES PIÈCES JOINTES ;
          les actes de la fenêtre et SES RELATIONS (gérant, tiers payeur, apporteur… — les
          lignes c_partner_partner hors adresses). Rien de l'identité ne descend sous ce bandeau.
       2. LES ADRESSES prennent tout le reste de la feuille, une par bande pleine largeur :
          les informations à gauche, la carte à droite. Une bande entière à 1536 px, deux et
          demie à 1920 (mesuré le 2026-10-23) ; au-delà, la liste défile — l'en-tête reste
          sous les yeux.

     Style de la fenêtre « Programmation de livraison » : papier blanc franc, filets de 1 px,
     aucune ombre, aucun aplat, l'ambre pour seul accent.

     DEUX MONTAGES, UN GABARIT (2026-09-15). En FENÊTRE (clic sur le nom du client d'une
     commande, relation ouverte par-dessus), la surface Material borne la feuille. En PAGE
     (/common/partner/:id, depuis la liste des tiers), la barre de menu de l'application est
     rendue au-dessus, comme sur toute page routée, et « Fermer » ramène à la liste.
     ══════════════════════════════════════════════════════════════════════════════════════ -->
<!-- IDENTIFIANTS `p2-*` : CONTRAT AVEC LES TESTS DE NON-RÉGRESSION (mercalink-nrts, binaire
     partnercreation, 2026-09-15). Le harnais Selenium crée des tiers par cette fiche, en PAGE
     (/common/partner), et ne vise que ces ids — jamais une classe ni un texte :
       p2-name, p2-firstname, p2-email, p2-tel1, p2-tel2, p2-act, p2-civ{0,1,2}, p2-pay{0,2} (id = valeur enregistrée, id de c_values 19)
       (radios déjà nommés), p2-save, p2-close (EN FENÊTRE seulement depuis le 23/10 : en page, sortir par le menu partnersbutton), p2-add-address, p2-docs-file (l'<input
       type=file> masqué des pièces du tiers : le harnais le dévoile et lui envoie un chemin)
       et p2-docs-add (son bouton « Ajouter » / « Dépôt… ») ;
       par bande d'adresse, `i` étant l'index de la liste des adresses (liveIndexes) :
       p2-adr-{i} (l'article), -bill / -deliv (les gélules, à CLIQUER : le radio dessous est
       masqué), -geocode (« Localiser »), -delete, -street1, -zip, -city, -street2, -street3,
       -country, -lat, -lng (lecture : la valeur posée par la BAN), -ban (le libellé retenu),
       -memo, -file / -docs-add (les pièces de l'adresse) ;
       p2-memo (le mémo du tiers lui-même, colonne 1), p2-orders (« Commandes »), p2-new-comptoir, p2-new-commande et p2-new-rent (F1 / F2 / F3 neuves), ces quatre-là client enregistré seulement.
     Renommer ou retirer l'un d'eux casse la suite « Clients » des NRT : la corriger en même
     temps (constantes P2_* de partnercreation/src/main.rs).
     Contrat valable écran ≥ 1100 px (harnais en 1800 × 950) : en dessous (compact), .mast-docs et .mast-right disparaissent,
     p2-docs-* n'existent qu'après un clic sur p2-fold-docs et p2-save / p2-close (fenêtre) / p2-orders / p2-new-* sont dans .compact-bar. -->
@if (!isDialog) {
	<app-menu-common url="sales"></app-menu-common>
}
@if (loading || !formGroup) {
	<div class="wait">Chargement du tiers…</div>
} @else {

<!-- Le formulaire EST la feuille : « Enregistrer » est un submit, et l'en-tête doit vivre dans
     le même <form> que les champs qu'il enregistre. -->
<form class="doc" [formGroup]="formGroup" (ngSubmit)="onSubmit()" novalidate>

	<!-- ═══ 1. L'EN-TÊTE — TROIS COLONNES 60 / 20 / 20 : le tiers et son mémo, ses pièces jointes, les actes puis ses relations.
	     La colonne 1 seule fait la hauteur (ses rangées passent à la ligne faute de place) ; 2 et 3 sont en absolu, leurs listes défilent. -->
	@if (compact) {
		<!-- Pseudo-mobile : la feuille défile d'un seul tenant et cette barre reste collée en haut — le tiers et ses actes toujours à l'écran. -->
		<div class="compact-bar">
			<span class="who">{{ fullName }}</span>
			<span class="docref"><i>N°</i>{{ id || '—' }}</span>
			<ng-container *ngTemplateOutlet="partnerActions" />
		</div>
	}
	<header class="mast">

		<!-- ═══ COLONNE 1 — LE TIERS ═══ Plafonnée par .mast (60 % de la feuille) : au-delà elle défile seule, les adresses gardent leur place. -->
		<div class="mast-left scroll-y">

		<!-- La rangée de titre : le nom, la référence, les rôles. Un nom long se coupe (…), les rôles passent à la ligne. -->
		<div class="mast-title">
			<span class="who">{{ fullName }}</span>
			<span class="docref"><i>N°</i>{{ id || '—' }}</span>

			<!-- Les rôles ne sont pas des controls mais une FormArray d'entiers : des bascules,
			     pas des cases à cocher Material de 40 px.
			     MÊME BOUTON QUE DANS LE SÉLECTEUR DE TIERS (app-partners, barre de filtres) :
			     même gabarit `role-toggle` + `r{id}` + `on`, même géométrie, mêmes trois
			     couleurs — bleu Client, ambre Fournisseur, violet Fabricant. Le rôle se lit
			     donc pareil d'un écran à l'autre, ce qui est tout l'intérêt d'un code couleur. -->
			<div class="roles" role="group" aria-label="Rôles du tiers">
				@for (r of roleChips; track r.id) {
					<button type="button" [class]="'role-toggle r' + r.id" [class.on]="hasRole(r.id)"
						[attr.aria-pressed]="hasRole(r.id)" (click)="toggleRole(r.id)">{{ r.label }}</button>
				}
			</div>
		</div>


		<!-- Rangée B1 — qui c'est. Le nom est le seul champ élastique. -->
		<div class="mast-fields">
			<div class="fld fld-civ">
				<span class="lbl">Civilité</span>
				<div class="seg">
					<input type="radio" id="p2-civ0" value="0" formControlName="civility"><label for="p2-civ0">Non précisée</label>
					<input type="radio" id="p2-civ1" value="1" formControlName="civility"><label for="p2-civ1">M.</label>
					<input type="radio" id="p2-civ2" value="2" formControlName="civility"><label for="p2-civ2">Mme</label>
				</div>
			</div>

			<div class="fld fld-name">
				<span class="lbl">Nom / Raison sociale</span>
				<input type="text" class="in" id="p2-name" formControlName="name" autocomplete="off">
			</div>

			<div class="fld fld-firstname">
				<span class="lbl">Prénom</span>
				<input type="text" class="in" id="p2-firstname" formControlName="firstname" autocomplete="given-name">
			</div>

		</div>

		<!-- Rangée B2 — ce qu'on sait de lui. Activité et paiement font --w-head, comme la forme juridique et l'encours
		     juste en dessous : les deux premières cellules de B2 et de C restent alignées, le reste passe à la ligne. -->
		<div class="mast-fields mast-fields-2">
			<div class="fld fld-act">
				<span class="lbl">Activité</span>
				<smart-select class="sel" id="p2-act" [items]="activities" formControlName="typ"
					bindLabel="name" bindValue="id" width="100%" height="24px" optionHeight="26px"></smart-select>
			</div>

			<div class="fld fld-pay">
				<span class="lbl">Paiement</span>
				<!-- value = id de c_values 19 (0 Comptant, 2 « 30 jours fin de mois » ; 1 y est « 30 jours net ») ; typpay vide = délai de la société, mais ce formulaire l'enregistre à 0. -->
				<div class="seg">
					<input type="radio" id="p2-pay0" value="0" formControlName="typpay"><label for="p2-pay0">Comptant</label>
					<input type="radio" id="p2-pay2" value="2" formControlName="typpay"><label for="p2-pay2">30j fin de mois</label>
				</div>
			</div>

			<div class="fld fld-tel">
				<span class="lbl">Tél. 1</span>
				<input type="tel" class="in" id="p2-tel1" formControlName="tel1" autocomplete="off">
			</div>

			<div class="fld fld-tel">
				<span class="lbl">Tél. 2</span>
				<input type="tel" class="in" id="p2-tel2" formControlName="tel2" autocomplete="off">
			</div>

			<div class="fld fld-email">
				<span class="lbl">E-mail</span>
				<input type="email" class="in" id="p2-email" formControlName="email" autocomplete="email">
			</div>
		</div>

		<!-- Rangée C — les cufs du tiers (c_values 12, composant 2), étiquette au-dessus. Les deux app-cuf sont en display: contents :
		     chaque champ est un élément de la rangée, qui passe à la ligne ; la tête (forme juridique, encours) prend la largeur --w-head. -->
		@if (cufsStructure.length && partnerCufGroup) {
			<div class="mast-cufs mast-cufs-main">
				<app-cuf class="cufs-head" [cufsStructure]="cufsHead" [cufGroup]="partnerCufGroup!" [inline]="false"></app-cuf>
				@if (cufsTail.length) {
					<app-cuf [cufsStructure]="cufsTail" [cufGroup]="partnerCufGroup!" [inline]="false"></app-cuf>
				}
			</div>
		}

		<!-- Rangée D — identité professionnelle (nom commercial, SIREN, TVA, APE, capital) :
		     repliée dès que la forme juridique est celle d'un particulier, même si ses champs
		     portent encore une valeur. Le SIRET n'y est pas : il est sur chaque adresse, dans la
		     rangée géo — et suit la même règle. -->
		@if (legalCufs.length && partnerCufGroup && legalBlockVisible) {
			<div class="mast-cufs">
				<app-cuf [cufsStructure]="legalCufs" [cufGroup]="partnerCufGroup!" [inline]="false"></app-cuf>
			</div>
		}

		<!-- Le mémo du tiers, unique (attach is_default_memo, objectid = id du tiers) : avec son identité, hors du carrousel
		     et de .mast-docs, dont la NRT compte les pièces. -->
		<div class="fld fld-memo mast-memo">
			<span class="lbl">
				Mémo
				@if (memoSaving.has(id)) { <em class="saving">enregistrement…</em> }
			</span>
			<textarea class="in memo" rows="2" id="p2-memo" [formControl]="partnerMemoCtrl" (blur)="onPartnerMemoBlur()"
				[placeholder]="isPersisted ? 'Ce que l’on veut noter sur ce tiers…' : 'Enregistrez le tiers pour pouvoir lui écrire un mémo'"></textarea>
		</div>

		<!-- REPRISE ORTHOP, TEMPORAIRE : fiche de l'ancien logiciel sous le mémo (documentation.html#front.common.partner.reprise-orthop). -->
		@if (isPersisted) { <app-reprise-orthop [partnerId]="id" /> }

		</div><!-- /mast-left -->

		<!-- Pseudo-mobile (compact, écran < 1100 px) : les colonnes 2 et 3 quittent l'en-tête — pièces et relations pliées au-dessus des
		     adresses, actes dans la barre du haut. Leur contenu est dans les ng-template de fin de feuille, rendu à un seul endroit à la fois. -->
		@if (!compact) {
		<!-- ═══ COLONNE 2 — LES PIÈCES JOINTES DU TIERS ═══ Même module `docs-col` que les pièces d'une adresse (objectid = id du tiers) :
		     vignettes de 224 px, « Ajouter » flottant en haut à droite ; un tiers non enregistré n'a pas d'id, rien ne s'y accroche. -->
		<section class="mast-docs docs-col">
			<ng-container *ngTemplateOutlet="partnerDocs" />
		</section>

		<!-- ═══ COLONNE 3 — LES ACTES DE LA FENÊTRE, PUIS LES RELATIONS ═══════════════════ -->
		<aside class="mast-right">
		<div class="mast-right-inner">

			<ng-container *ngTemplateOutlet="partnerActions" />

			<!-- LES RELATIONS : les lignes c_partner_partner du tiers HORS adresses (gérant,
			     personne habilitée au retrait, tiers payeur, apporteur…). ÉCRITES AU CLIC, comme
			     les pièces jointes : rattacher poste une ligne INSERT, la corbeille une ligne
			     DELETE, chacune par son propre event, sans attendre « Enregistrer ». Les liens
			     d'adresse (rôles -1, -2, -5, et tout rôle « applies_to: address ») ne sont pas
			     des relations : ils se lisent et s'éditent dans les bandes d'adresse. Un tiers
			     pas encore enregistré n'a pas d'id : rien ne peut s'y rattacher. -->
			<section class="pane pane-rel">
				<!-- Titre du volet au-dessus de sa liste : sur la ligne des actes, « Relations » était tronqué à 1 536 px. -->
				<div class="rel-head">
					<span class="lbl">Relations</span>
					@if (relationCount) { <span class="count">{{ relationCount }}</span> }
				</div>
				<ng-container *ngTemplateOutlet="partnerRelations" />
			</section>

		</div><!-- /mast-right-inner -->
		</aside>
		}
	</header>

	<!-- ═══ 2. LES ADRESSES ══════════════════════════════════════════════════════════════
	     Une adresse = une bande pleine largeur. À gauche tout ce qui se saisit, à droite la
	     carte : en mode large, c'est la zone qui défile quand les bandes dépassent la place laissée par l'en-tête (en compact, la feuille entière). -->
	<section class="adrs scroll-y">

		@if (compact) {
			<!-- Pseudo-mobile : pièces jointes et relations du tiers, pliées ; un clic sur l'intitulé les déplie. -->
			<div class="folds">
				<section class="fold">
					<button type="button" class="fold-head" id="p2-fold-docs" [attr.aria-expanded]="docsOpen" (click)="docsOpen = !docsOpen">
						<mat-icon>{{ docsOpen ? 'expand_more' : 'chevron_right' }}</mat-icon><span class="lbl">Pièces jointes</span>
						@if (partnerAttachs.length) { <span class="count">{{ partnerAttachs.length }}</span> }
					</button>
					@if (docsOpen) {
						<div class="fold-docs docs-col" [class.empty]="!partnerAttachs.length"><ng-container *ngTemplateOutlet="partnerDocs" /></div>
					}
				</section>
				<section class="fold">
					<button type="button" class="fold-head" id="p2-fold-rel" [attr.aria-expanded]="relOpen" (click)="relOpen = !relOpen">
						<mat-icon>{{ relOpen ? 'expand_more' : 'chevron_right' }}</mat-icon><span class="lbl">Relations</span>
						@if (relationCount) { <span class="count">{{ relationCount }}</span> }
					</button>
					@if (relOpen) {
						<div class="fold-rel pane"><ng-container *ngTemplateOutlet="partnerRelations" /></div>
					}
				</section>
			</div>
		}

		@if (!liveCount) {
			<div class="none">Aucune adresse — ajoutez-en une ci-dessous.</div>
		}

		<!-- Suivi par le `child` de l'adresse, pas par sa position : la liste est re-triée quand
		     une qualité change (facturation d'abord) et une ligne supprimée en sort — suivie par
		     l'index, une bande changerait d'adresse sous ses composants (app-cuf appliquerait
		     ses règles à la mauvaise, et la bande détruite ne serait pas celle de l'adresse
		     supprimée) ; suivie par l'adresse, elle la suit, et disparaît avec elle. -->
		<!-- Des objets {child, i} et non des index : sur un entier resté au même rang, @for ne lit jamais track et gardait la bande en place (radio p2-bill resté coché sur l'autre adresse, clic Facturation muet). -->
		@for (b of liveBands; track b.child) {
			@let i = b.i;
			<article class="adr" [id]="'p2-adr-' + i">

				<!-- ═══ TIERS 1 — TOUT CE QUI SE SAISIT, ET LE MÉMO ═══════════════════════════
				     Plus de titre en toutes lettres devant les deux gélules : « Facturation +
				     Livraison » n'apprenait rien que les gélules ne disent déjà, et sa longueur
				     variable DÉPLAÇAIT le bouton qu'on visait au moment même où on cliquait. Les
				     gélules ouvrent maintenant la ligne, à une position fixe. -->
				<div class="adr-info">

					<div class="adr-head">
						<label class="flag" [id]="'p2-adr-' + i + '-bill'" [class.on]="isBill(i)" (click)="onFlagClick($event)"
							matTooltip="Adresse de facturation par défaut — une seule à la fois">
							<input type="radio" name="p2-bill" [checked]="isBill(i)" (change)="setBill(i)">
							<span>Facturation</span>
						</label>
						<label class="flag" [id]="'p2-adr-' + i + '-deliv'" [class.on]="isDeliv(i)" (click)="onFlagClick($event)"
							matTooltip="Adresse de livraison par défaut — une seule à la fois">
							<input type="radio" name="p2-deliv" [checked]="isDeliv(i)" (change)="setDeliv(i)">
							<span>Livraison</span>
						</label>

						<span class="grow"></span>

						<button type="button" class="btn small" [id]="'p2-adr-' + i + '-geocode'" [disabled]="geoBusy(i)"
							matTooltip="Calculer les coordonnées GPS depuis l'adresse (Base Adresse Nationale)"
							(click)="onGeocode(i)"><mat-icon>my_location</mat-icon>{{ geoBusy(i) ? 'Localisation…' : 'Localiser' }}</button>
						<button type="button" class="icon-btn danger" [id]="'p2-adr-' + i + '-delete'" matTooltip="Supprimer cette adresse"
							aria-label="Supprimer cette adresse" (click)="deleteAddress(i)"><mat-icon>delete</mat-icon></button>
					</div>

					<!-- Rangée 1 — la voie, le code postal, la ville : la ligne postale qui compte. -->
					<div class="adr-row">
						<div class="fld fld-street">
							<span class="lbl">N° et rue</span>
							<input type="text" class="in" [id]="'p2-adr-' + i + '-street1'" [formControl]="ctrl(i, 'street1')" autocomplete="off">
						</div>
						<div class="fld fld-zip">
							<span class="lbl">Code postal</span>
							<input type="text" class="in num" [id]="'p2-adr-' + i + '-zip'" [formControl]="ctrl(i, 'zip')" autocomplete="off">
						</div>
						<div class="fld fld-city">
							<span class="lbl">Ville</span>
							<input type="text" class="in" [id]="'p2-adr-' + i + '-city'" [formControl]="ctrl(i, 'city')" autocomplete="off">
						</div>
					</div>

					<!-- Rangée 2 — les compléments. Convention des colonnes c_partner, celle de la
					     base : street2 = entrée/bâtiment/résidence, street3 = appartement/étage. -->
					<div class="adr-row">
						<div class="fld fld-c2">
							<span class="lbl">Entrée / Bât. / Résidence</span>
							<input type="text" class="in" [id]="'p2-adr-' + i + '-street2'" [formControl]="ctrl(i, 'street2')" autocomplete="off">
						</div>
						<div class="fld fld-c3">
							<span class="lbl">Appart. / Étage</span>
							<input type="text" class="in" [id]="'p2-adr-' + i + '-street3'" [formControl]="ctrl(i, 'street3')" autocomplete="off">
						</div>
						<div class="fld fld-country">
							<span class="lbl">Pays</span>
							<smart-select class="sel" [id]="'p2-adr-' + i + '-country'" [items]="countryItems(i)" bindLabel="label" bindValue="value"
								[formControl]="ctrl(i, 'country')" placeholder="Pays" width="100%" height="24px" optionHeight="26px"></smart-select>
						</div>
					</div>

					<!-- Rangée 3 — LES COORDONNÉES SE SAISISSENT. Un relevé pris au camion, un point
					     lu sur une autre carte, une position que la BAN met au centre de la commune :
					     il faut pouvoir les écrire à la main, sans passer par l'épingle. À droite,
					     ce que la BAN a RÉELLEMENT compris — rien d'autre à l'écran ne dit qu'un
					     « 9 CH DE LA CHAPELLE QUARTIER » a été résolu en « Allée de la Clairière ». -->
					<div class="adr-row">
						<div class="fld fld-lat">
							<span class="lbl">Latitude</span>
							<input type="text" inputmode="decimal" class="in num" [id]="'p2-adr-' + i + '-lat'" autocomplete="off"
								[value]="geoLat(i) ?? ''" (input)="onCoordInput(i, 'lat', $event)"
								matTooltip="Latitude en degrés décimaux — vider le champ efface la position">
						</div>
						<div class="fld fld-lng">
							<span class="lbl">Longitude</span>
							<input type="text" inputmode="decimal" class="in num" [id]="'p2-adr-' + i + '-lng'" autocomplete="off"
								[value]="geoLng(i) ?? ''" (input)="onCoordInput(i, 'lng', $event)"
								matTooltip="Longitude en degrés décimaux — vider le champ efface la position">
						</div>
						<div class="fld fld-ban">
							<span class="lbl">Base Adresse Nationale</span>
							<div class="ban-line" [id]="'p2-adr-' + i + '-ban'">
								@if (geoErr(i); as err) {
									<span class="ban err" [matTooltip]="err"><mat-icon>error_outline</mat-icon>{{ err }}</span>
								} @else if (banLabel(i)) {
									<span class="ban" [class.doubt]="banDoubt(i)" [matTooltip]="banDoubt(i)
										? 'Position approchée : elle n’est PAS enregistrée. Déplacez l’épingle sur la carte, ou saisissez les coordonnées, pour la corriger.'
										: 'Libellé retenu par la Base Adresse Nationale'">
										<mat-icon>{{ banDoubt(i) ? 'help_outline' : 'check' }}</mat-icon>{{ banLabel(i) }}</span>
								} @else {
									<span class="ban none">—</span>
								}
							</div>
						</div>
						<!-- LE SIRET, ICI ET PAS DANS L'EN-TÊTE : c'est un numéro d'ÉTABLISSEMENT, une
						     société à trois adresses en a trois. Rendu par app-cuf (largeur, étiquette,
						     normalisation du référentiel), sur le groupe de cufs de CETTE adresse, et
						     seulement pour un tiers professionnel — un particulier n'en a pas. -->
						@if (siretCufs.length && legalBlockVisible && addressCufGroup(i)) {
							<div class="fld fld-siret">
								<app-cuf [cufsStructure]="siretCufs" [cufGroup]="addressCufGroup(i)" [inline]="false"></app-cuf>
							</div>
						}
					</div>

					<!-- Rangée 4 — LES CUFS DE L'ADRESSE (composant 1, hors SIRET) : niveau, code
					     porte… ce que le référentiel c_values 12 déclare, rendu génériquement par
					     app-cuf sur le groupe data.cufs de CETTE adresse — c'est ce que lit la
					     logistique (DelrunsService.addressDetailsOf). Absente si la base n'en déclare
					     aucun. -->
					@if (otherAddressCufs.length && addressCufGroup(i)) {
						<div class="adr-row adr-cufs" [id]="'p2-adr-' + i + '-cufs'">
							<app-cuf [cufsStructure]="otherAddressCufs" [cufGroup]="addressCufGroup(i)" [inline]="false"></app-cuf>
						</div>
					}

					<!-- Le MÉMO. Ce n'est pas une colonne de c_partner mais un ATTACH « mémo » de
					     l'adresse, comme celui d'un bon de livraison : il s'écrit par sa propre voie,
					     au départ du curseur, et non avec le reste de la fiche. -->
					<div class="fld fld-memo">
						<span class="lbl">
							Mémo
							@if (memoSaving.has(addressId(i))) { <em class="saving">enregistrement…</em> }
						</span>
						<!-- Pas de [disabled] ici : sur une ligne neuve, memoCtrl rend un control DÉJÀ
						     désactivé — c'est le modèle qui porte l'état, pas un attribut posé à côté. -->
						<textarea class="in memo" rows="2" [id]="'p2-adr-' + i + '-memo'" [formControl]="memoCtrl(i)" (blur)="onMemoBlur(i)"
							[placeholder]="canAttach(i) ? 'Consigne de livraison, code d’accès, étage, contact sur place…' : 'Enregistrez l’adresse pour pouvoir lui joindre un mémo'"></textarea>
					</div>
				</div>

				<!-- ═══ TIERS 2 — LES PIÈCES JOINTES ═════════════════════════════════════════
				     Photo de la porte, plan d'accès, badge, bon de dépôt. Elles se rattachent à
				     la LIGNE d'adresse (objecttyp PARTNER, objectid = id de la ligne) : une
				     adresse pas encore enregistrée n'a pas d'id, donc rien ne peut s'y accrocher.
				     LE MÊME MODULE QUE LA COLONNE 2 DE L'EN-TÊTE (classe `docs-col`, un seul CSS
				     pour les deux, 2026-09-15) : ni titre ni compteur, le bouton « Ajouter »
				     flotte dans le coin haut droit et les vignettes prennent toute la hauteur du
				     tiers, dès le bord haut — elles passent sous le bouton quand la largeur manque. -->
				<div class="adr-docs docs-col" [class.empty]="!attachsOf(i).length">
					@if (canAttach(i)) {
						<input type="file" hidden [id]="'p2-adr-' + i + '-file'" #fileInput (change)="onFileSelected(i, $event)">
						<button type="button" class="btn small docs-add" [id]="'p2-adr-' + i + '-docs-add'" [disabled]="uploading.has(addressId(i))"
							matTooltip="Joindre une pièce à l'adresse" (click)="fileInput.click()"><mat-icon>attach_file</mat-icon>{{ uploading.has(addressId(i)) ? 'Dépôt…' : 'Ajouter' }}</button>
					}

					<!-- Le carrousel DÉJÀ EN SERVICE ailleurs (fiche article, programmation de
					     livraison). Il fait tout ce qu'on attend d'une pièce jointe — l'ouvrir, la
					     renommer, la déplacer dans la séquence, la désigner image par défaut, la
					     télécharger, la supprimer — et il écrit lui-même en base. On lui passe le
					     tableau de l'adresse et on ne s'en mêle plus ; seule sa TAILLE est reprise
					     dans le SCSS — la même que dans l'en-tête. -->
					<div class="docs-body scroll-y">
						@if (attachsOf(i).length) {
							<!-- Le carrousel modifie EN PLACE le tableau qu'on lui passe (suppression =
							     splice) : c'est la même instance que celle de la table `attachs`, il n'y
							     a donc rien à réémettre ni à recopier au retour. -->
							<app-image-carousel [attachs]="attachsOf(i)" [canEdit]="true"></app-image-carousel>
						} @else {
							<div class="docs-none">
								@if (canAttach(i)) { Aucune pièce jointe } @else { Adresse non enregistrée }
							</div>
						}
					</div>
				</div>

				<!-- ═══ TIERS 3 — LA CARTE ═══════════════════════════════════════════════════
				     Sa hauteur est le littéral MAP_H de la classe, que le .scss réserve à
				     l'identique : app-mini-map calcule sa mosaïque de tuiles depuis son entrée
				     [height], pas depuis sa boîte. L'état vide fait EXACTEMENT la même hauteur,
				     sinon la bande se déformerait au premier géocodage. -->
				<div class="adr-map">
					@if (hasGeo(i)) {
						<app-mini-map [lat]="geoLat(i)" [lon]="geoLng(i)" [height]="MAP_H"
							[label]="geoLabel(i)" (coordsChange)="onMapCoords(i, $event)"></app-mini-map>
					} @else {
						<div class="map-miss">
							<mat-icon>wrong_location</mat-icon>
							@if (geoErr(i) === GEO_INJOIGNABLE) {
								<span>Base Adresse Nationale injoignable — l’adresse n’est pas en cause : cliquez de nouveau « Localiser ».</span>
							} @else {
								<span>Adresse non localisée — complétez la rue, le code postal et la ville, puis « Localiser ».</span>
							}
						</div>
					}
				</div>
			</article>
		}

		<!-- Le pied de liste, dans la continuité des bandes : un lien, pas un bouton plein. -->
		<div class="adr-add">
			<button type="button" class="btn" id="p2-add-address" (click)="addAddress()"><mat-icon>add</mat-icon>Ajouter une adresse</button>
		</div>
	</section>

	<!-- ═══ CONTENUS RENDUS À UN SEUL ENDROIT : colonnes 2 et 3 en mode large, barre et volets pliés en compact (ids p2-* uniques). -->
	<ng-template #partnerActions>
		<!-- Ce qu'on fait de la fenêtre — « Enregistrer » est le submit du formulaire. Toujours à l'écran : en tête de la colonne 3 (≥ 160 px,
		     jamais hors de la feuille, boutons repliés à la ligne) ou, en compact, dans la barre collée en haut de la feuille qui défile. -->
		<div class="mast-actions">
			<!-- Rôle Client EN BASE seulement ; grisé tant que la fiche est modifiée ou s'enregistre, en page comme en fenêtre (openOrders).
			     L'infobulle est sur le span : un bouton grisé ne reçoit pas la souris (pointer-events coupé dans le scss). -->
			@if (canOpenOrders) {
				<!-- F1 / F2 / F3 neuves pour ce client, dans l'ordre du menu, à gauche de « Commandes » (JP, 26/10) : mêmes conditions, en fenêtre dans un nouvel onglet (openNewSale).
				     Icônes seules, serrées en groupe, nommées par l'infobulle : avec leurs libellés, la croix passait sur une 2e ligne à 1 920 px et la barre sur 3 à 1 536. -->
				<span class="sale-acts">
					@for (k of NEW_SALE_KINDS; track k) {
						<span class="sale-tip" [matTooltip]="saleTip(k)">
							<button type="button" class="btn small ico" [id]="'p2-new-' + k" [disabled]="saving || hasUnsavedChanges" (click)="openNewSale(k)"
								[attr.aria-label]="NEW_SALE_DOCUMENTS[k].label"><mat-icon>{{ NEW_SALE_DOCUMENTS[k].icon }}</mat-icon></button>
						</span>
					}
				</span>
				<!-- Consultation, calée à droite contre « Enregistrer », un grand espace la sépare des saisies neuves (JP, 29/10) : commandes, puis dossiers de location (vue du payeur). -->
				<span class="see-acts">
					<span class="orders-tip" [matTooltip]="hasUnsavedChanges ? 'Vous devez d’abord enregistrer la fiche avant de pouvoir ouvrir les commandes' : 'Commandes du client depuis ' + ORDERS_YEARS + ' ans'">
						<button type="button" class="btn small" id="p2-orders" [disabled]="saving || hasUnsavedChanges" (click)="openOrders()"
							aria-label="Commandes"><mat-icon>receipt_long</mat-icon><span class="orders-txt">Commandes</span></button>
					</span>
					<span class="rentals-tip" [matTooltip]="rentalsTip()">
						<button type="button" class="btn small" id="p2-rentals" [disabled]="saving || hasUnsavedChanges" (click)="openRentals()"
							aria-label="Locations"><mat-icon>folder_shared</mat-icon><span class="orders-txt">Locations</span></button>
					</span>
				</span>
			}
			<!-- Grisé tant qu'un champ enfreint sa définition (cufs : obligatoire, bornes,
			     entier — le champ est en rouge et son infobulle dit la règle). Voir
			     CufComponent.applyRules ; l'enregistrement est aussi refusé dans onSubmit. -->
			<button type="submit" class="btn green" id="p2-save" [disabled]="saving || formGroup.invalid"
				[matTooltip]="formGroup.invalid ? 'Corrigez les champs en rouge' : ''">
				<mat-icon>save</mat-icon>{{ saveLabel }}</button>
			<!-- En fenêtre seulement (JP, 23/10) : une page ne se ferme pas, on en sort par le menu ou le retour arrière (garde canLeave). -->
			@if (isDialog) {
				<button type="button" class="icon-btn danger" id="p2-close" [disabled]="saving"
					matTooltip="Fermer" aria-label="Fermer" (click)="close()"><mat-icon>close</mat-icon></button>
			}
		</div>
	</ng-template>

	<ng-template #partnerDocs>
		@if (isPersisted) {
			<input type="file" hidden id="p2-docs-file" #partnerFile (change)="onPartnerFileSelected($event)">
			<button type="button" class="btn small docs-add" id="p2-docs-add" [disabled]="uploading.has(id)"
				matTooltip="Joindre une pièce au tiers" (click)="partnerFile.click()"><mat-icon>attach_file</mat-icon>{{ uploading.has(id) ? 'Dépôt…' : 'Ajouter' }}</button>
		}
		<div class="docs-body scroll-y">
			@if (partnerAttachs.length) {
				<!-- Même instance que celle de la table `attachs` : le carrousel la modifie en
				     place (suppression = splice), rien à réémettre. -->
				<app-image-carousel [attachs]="partnerAttachs" [canEdit]="true"></app-image-carousel>
			} @else {
				<div class="docs-none">
					@if (isPersisted) { Aucune pièce jointe } @else { Enregistrez le tiers pour pouvoir lui joindre des pièces }
				</div>
			}
		</div>
	</ng-template>

	<ng-template #partnerRelations>
		@if (!isPersisted) {
			<div class="rel-none">Enregistrez le tiers pour pouvoir lui rattacher des tiers.</div>
		} @else {

		<!-- L'AJOUT, SUR DEUX LIGNES — la colonne est étroite : le tiers d'abord, sur
		     toute la largeur ; le titre et le bouton dessous. Le sélecteur est celui de
		     toute l'application (recherche par nom / prénom / NIR, sans filtre de rôle :
		     un gérant est une personne, un tiers payeur un organisme). Le tiers choisi
		     s'écrit dans le champ même ; la croix le libère. Les rôles proposés excluent
		     ceux des adresses. -->
		<div class="rel-add">
			<app-search-partner class="rel-search" [roles]="[]" [showSelectionInInput]="true"
				[currentPartner]="newRelPartner" [resetComponentSubject]="relSearchReset" width="100%"
				(partnerChange)="onNewRelPartner($event)"></app-search-partner>
		</div>
		<div class="rel-add">
			<smart-select class="sel rel-role" [items]="relationRoleItems" bindLabel="label" bindValue="value"
				[formControl]="newRelRole" placeholder="À quel titre ?" width="100%" height="24px" optionHeight="26px"></smart-select>
			<button type="button" class="btn small" [disabled]="!canAddRelation" matTooltip="Rattacher ce tiers"
				aria-label="Rattacher ce tiers" (click)="addRelation()"><mat-icon>add_link</mat-icon></button>
		</div>

		<!-- LA LISTE : une relation = deux lignes — le nom et le numéro du tiers, puis le
		     titre et la corbeille. Une ligne par (tiers, titre) : la même personne peut
		     être gérante ET habilitée au retrait, ce sont deux relations. Le nom OUVRE LA
		     FICHE du tiers rattaché (une fenêtre par-dessus celle-ci : la fiche en cours
		     n'est pas quittée, sa saisie non plus) ; son numéro distingue deux homonymes.
		     La corbeille retire la relation, pas le tiers. Une ligne grisée voyage. -->
		<div class="rel-list scroll-y">
			@if (!relations.length) {
				<div class="rel-none">{{ relationsLoading ? 'Lecture des relations…' : 'Aucun tiers rattaché.' }}</div>
			}
			@for (r of relations; track r.key) {
				<div class="rel-row" [class.busy]="r.busy">
					<button type="button" class="rel-name" [disabled]="r.busy" (click)="openRelated(r)"
						[matTooltip]="'Ouvrir la fiche du tiers n° ' + r.childId">{{ r.label }}</button>
					<span class="rel-id">n°&nbsp;{{ r.childId }}</span>
					<span class="rel-pill" [class.default]="r.isDefault"
						[matTooltip]="r.roleName + (r.isDefault ? ' — rattachement principal pour ce titre' : '')">
						{{ r.roleName }}@if (r.isDefault) { <mat-icon>star</mat-icon> }
					</span>
					<button type="button" class="icon-btn danger rel-del" [disabled]="r.busy" matTooltip="Retirer cette relation"
						aria-label="Retirer cette relation" (click)="removeRelation(r)"><mat-icon>delete</mat-icon></button>
				</div>
			}
		</div>

		}
	</ng-template>
</form>
}
